import React from 'react'

function Testimonials() {
  return (
    <div>Testimonials</div>
  )
}

export default Testimonials